module.exports = __webpack_public_path__ + "assets/img/out_(1).92bc23f3.gif";